// Contactos do estúdio usados em botões e ligações
export const WHATSAPP_NUMERO = '351932306390';

// Abre o WhatsApp da Márcia com a mensagem já escrita
export function linkWhatsApp(mensagem) {
  return `https://wa.me/${WHATSAPP_NUMERO}?text=${encodeURIComponent(mensagem)}`;
}

export const MENSAGEM_VALE_PRESENTE = 'Olá, gostaria de oferecer um vale-presente da Márcia Monteiro Wellness neste Natal.';

export const MENSAGEM_AULA_GRATIS = 'Olá, gostaria de marcar a minha aula experimental grátis de Yoga/Pilates.';
